import animateCssStyles from "./animate.css?inline";

export const animateCss = animateCssStyles;
